export default "__VITE_ASSET__XaED47nf__"